// src/dialog/src/dialog-elements/DialogTitle.tsx
import { Title } from "@radix-ui/react-dialog";
import { jsx } from "react/jsx-runtime";
var DialogTitle = ({ children, ...rest }) => /* @__PURE__ */ jsx(
  Title,
  {
    className: "mb-5 w-11/12 text-xl font-medium text-surface-dark",
    ...rest,
    children
  }
);

export {
  DialogTitle
};
